import Anchor from './Anchor';
import Helper from './Helper';

class AnchorPDF {
  constructor(config = {}) {
    const {
      anchorSelector
    } = config;
    this.links = document.querySelectorAll(anchorSelector);
    this.linksArray = Array.prototype.slice.call(this.links);
    if(this.links.length > 0){
      this.change();
    }

    // trigger scroll if location.hash is not empty
    let locationHash = location.hash.replace('#', '');
    if (locationHash !== "") {
      // setTimeout to force scroll to correct position
      setTimeout(function(){
        new Anchor({
          anchorId: locationHash
        });
      }, 200);
    }
  }

  change(){
    this.linksArray.forEach((link, i) => {
      const idName = link.innerText;
      if (link.nextElementSibling) {
        link.nextElementSibling.id = idName;
      } else {
        console.warn('link.nextElementSibling does not exist: ', idName);
      }
      link.remove();

      // const idName = link.innerText;
      // const aTag = document.createElement('a');
      // aTag.id = idName;
      // Helper.addClass(aTag, 'ns-anchor');
      // Helper.addAfter(aTag, link);
      // link.remove();
    });
  }

}

export default AnchorPDF;
